import { useSelector } from 'react-redux';

import * as api from '../../api';
import * as store from '../../reducers/store';

import { Button } from '../Button';

export const ScheduleLink: React.FC = () => {
  const selectedFormId = useSelector(
    (s: store.FormSetSelected) => s.selectedFormId,
  );
  const formSetId = useSelector(
    (s: store.FormSetSelected) => s.selectedFormSetId,
  );
  if (!selectedFormId) return null;
  return (
    <div>
      <Button
        onClick={async (evt) => {
          evt.preventDefault();
          evt.stopPropagation();
          const link = await api.client.Previsit.getScheduleLink(formSetId);
          api.client.Previsit.completeForm(selectedFormId);
          window.location.assign(link);
        }}
      >
        Click to schedule your appointment
      </Button>
    </div>
  );
};
